export class ApplicantBasic {
    constructor(
        public RentalApplicationKey: number = null,
        public RentalApplicantKey: number = 0,
        public Identity: string = '',
        public name: string = '',
        public FirstName: string = '',
        public MiddleName: string = '',
        public LastName: string = '',
        public HomePhone: string = '',
        public CellPhone: string = '',
        public Email: string = '',
        public DesiredMoveInDate: Date = null,
        public ApplicantStatus: string = '',
        public RentalMoveInReasonKey: number = null,
        public createdAt: Date = null,
        public updatedAt: Date = null,
        public IsWaitListed: boolean = false,
        public LeasingAgent: number = null,
        public ExternalAgentName: string = '',
        public HasExternalAgent: boolean = null,
        public hasReferrals: boolean = null,
        public ReferralName: string = '',
        public LeaseTerm: number = null,
        public IsPrimary: boolean = false,
        public IsInvite: boolean = false,
        public CompletedByOther: boolean = false,
        public RentalApplicantParentKey: number = null,
        public InviteHRA: string = null,
        public InterestedInSmartHome: boolean = null,
        public Campaign: string = null,
        public Source: string = null,
        public AdGroup: string = null,
        public Keyword: string = null,
        public AdCopy: string = null,
        public Device: string = null,
        public Medium: string = null,
        public RentalApplicationInvitationKey: number = null,
        public RentalRateRent: number = null,
    ) { }
}